import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/stores/authStore';
import { usePreviewStore } from '@/stores/previewStore';
import { StudentDashboard } from '@/features/Dashboard/StudentDashboard';

export const Route = createFileRoute('/dashboard/')({
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }
    // Trainers / super admins in "preview as student" mode stay on the
    // student dashboard instead of bouncing to their role home.
    if (
      usePreviewStore.getState().active &&
      (user?.role === 'trainer' || user?.role === 'super_admin')
    ) {
      return;
    }
    if (user?.role === 'super_admin') {
      throw redirect({ to: '/admin/dashboard' });
    }
    if (user?.role === 'trainer') {
      throw redirect({ to: '/trainer/dashboard' });
    }
    if (user?.role === 'org_admin') {
      throw redirect({ to: '/org' });
    }
  },
  component: DashboardPage,
});

function DashboardPage() {
  return <StudentDashboard />;
}
